import { createSlice } from '@reduxjs/toolkit';
import { _setActId,
    _setActivityByWestCareEmployee, 
    _setActivityType, 
    _setActivityWithContactName, 
    _setActivityWithContactType, 
    _setDateCompleted,
    _setDateEarly,
    _setDateLate,
    _setIs12StepQuestionAnswered,
    _setIs12StepQuestionAsked,
    _setPriority,
    _setRecdCBPROI,
    _setActivityNote
} from '../activitiesAction';
import initialState from '../activitiesInitialState';

export const episodeActivitySlice = createSlice({
  name: 'activities',
  initialState,
  reducers: {
    activities: (state, action) => {
      state.activitiesDetail = action.payload
    },
    setActId: _setActId,
    setDateCompleted: _setDateCompleted,
    setDateEarly: _setDateEarly,
    setDateLate: _setDateLate,
    setActivityType: _setActivityType,
    setActivityWithContactType: _setActivityWithContactType,
    setActivityWithContactName: _setActivityWithContactName,
    setActivityByWestCareEmployee: _setActivityByWestCareEmployee,
    setPriority: _setPriority,
    setIs12StepQuestionAsked: _setIs12StepQuestionAsked,
    setIs12StepQuestionAnswered: _setIs12StepQuestionAnswered,
    setRecdCBPROI: _setRecdCBPROI,
    setActivityNote: _setActivityNote,
    resetActivities: () => initialState,
  },
});

export const { 
  activities,
  setActId,
  setDateCompleted,
  setDateEarly,
  setDateLate,
  setActivityType,
  setActivityWithContactType,
  setActivityWithContactName,
  setActivityByWestCareEmployee,
  setPriority,
  setIs12StepQuestionAsked,
  setIs12StepQuestionAnswered,
  setRecdCBPROI,
  setActivityNote,
  resetActivities 
} = episodeActivitySlice.actions;

export default episodeActivitySlice.reducer;
